import { render, staticRenderFns } from "./Trademark.vue?vue&type=template&id=603a6e2d&scoped=true&"
import script from "./Trademark.vue?vue&type=script&lang=js&"
export * from "./Trademark.vue?vue&type=script&lang=js&"
import style0 from "./Trademark.vue?vue&type=style&index=0&id=603a6e2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603a6e2d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VContainer})
